import React, { FC } from 'react'
import { CircularProgress } from '@material-ui/core'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Formik } from 'formik'
import { WelcomeModalSchema } from '../../../utils/validation'
import ActionData from '../../../types/ActionData'
import { mainColors } from '../../../assets/colors'
import './index.css'

interface Props {
  addingProviderApplication: boolean;
  addProviderApplication: ActionData;
  show: boolean;
  onSubmit: (values: any) => void;
}

const initialValues = {
  applicationType: '',
  '12BedCertification': ''
}

const GettingStartedModal: FC<Props> = ({ addingProviderApplication, addProviderApplication, show, onSubmit }: Props) => {
  const loadingIcon = addProviderApplication.error !== false ? <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color={mainColors.loadingBlue} className="modal-success-icon" /> : <CircularProgress size={70} />
  const modalText =  addProviderApplication.error !== false ? 'The data could not be saved.' : ''

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={WelcomeModalSchema}
      onSubmit={(values, {setSubmitting}) => {
        onSubmit(values)
        setSubmitting(false)
      }}
    >
      {({
        dirty,
        errors,
        isValid,
        values,
        setFieldValue,
        handleSubmit
      }) => {
        const handleHide = () => {
          if (dirty && isValid) onSubmit(values)
        }
        return (
          <Modal size='lg' show={show} onHide={handleHide}>
            <Modal.Header closeButton id='modal-header'>
              <FontAwesomeIcon icon={['fas', 'info-circle']} size='lg' className='modal-header-icon' />
              <Modal.Title id='modal-header-title'>Getting Started</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {addingProviderApplication ? ( 
                addProviderApplication.loading || addProviderApplication.error!== false ? (
                  <div className="modal-loading-container">
                    {loadingIcon}
                    <span className="modal-loading-text" style={addProviderApplication.error!== false ? { width: '100%' } : {}}>
                      {modalText}
                    </span>
                  </div> ) : null
              ) : (
                <Form noValidate onSubmit={handleSubmit}>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ fontSize: '1.5rem'}}>Welcome to the Provider Application.</span>
                    <span style={{ fontSize: '1.5rem'}}>Please choose application type below to get started.</span>
                  </div>
                  <Row style={{ marginTop: 15 }}>
                    <Col xs={3} />
                    <Form.Group as={Col} xs={6}>
                      <Form.Control
                        as='select'
                        value={values.applicationType}
                        name='applicationType'
                        onChange={(event: any) => setFieldValue('applicationType', event.target.value)}
                      >
                        <option value="">Select an application type.</option>
                        <option value="non-residential">Non-Residential</option>
                        <option value="residential">Residential</option>
                      </Form.Control>
                      {errors.applicationType ? (
                        <Form.Text className="form-error">
                          {errors.applicationType}
                        </Form.Text>
                      ) : null}
                    </Form.Group>
                    <Col xs={3} />
                  </Row>
                  {
                    values.applicationType === 'residential' ? (
                      <Row style={{ marginTop: 15 }}>
                        <Col xs={3} />
                        <Form.Group as={Col} xs={6}>
                          <Form.Control
                            as='select'
                            value={values['12BedCertification']}
                            name='12BedCertification'
                            onChange={(event: any) => setFieldValue('12BedCertification', event.target.value)}
                          >
                            <option value="">Select an option:</option>
                            <option value="true">Need certification for 1-2 bed AFH</option>
                            <option value="false">Do Not Need certification for 1-2 bed AFH</option>
                          </Form.Control>
                          {errors['12BedCertification'] ? (
                            <Form.Text className="form-error">
                              {errors['12BedCertification']}
                            </Form.Text>
                          ) : null}
                        </Form.Group>
                        <Col xs={3} />
                      </Row>
                    ) : null
                  }
                  <div
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <Button
                      type='submit'
                      variant='info'
                      style={{ width: '150px' }}
                    >
                                                Continue
                    </Button>
                  </div>
                </Form>
              )}
            </Modal.Body>
          </Modal>
        )
      }}
    </Formik>
  )
}

export default GettingStartedModal
